import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[appUploaderErrors]'
})
export class UploaderErrorsDirective {
  @Input() errors: any;

  constructor(public templateRef: TemplateRef<unknown>, public containerRef: ViewContainerRef) {
    this.containerRef.createEmbeddedView(templateRef, {errors: this.errors});
  }
}
